export default __webpack_public_path__ + "static/media/information--tsunami-evacuation_route--g1.7ae34865.png";